import React, { useState, useEffect } from 'react';
import './add-employee.css';
import Grid from '@mui/material/Grid';
import http from '../../services/http-service'
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useHistory } from "react-router-dom";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { ToastContainer, toast } from 'react-toastify';
import checkValidationFormAllControls from '../../constants/validation';
import { getErrorResponse } from '../../utils';
import DatePicker from "react-modern-calendar-datepicker";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Moment from 'moment';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';


const CustomInput = React.forwardRef((props, ref) => {
  return (
    <input
      className={[ref.classes.TransparentInput, "uk-input"].join(" ")}
      onClick={props.onClick}
      value={props.value}
      type="text"
      disabled={true}
      ref={ref}
    />
  )

})

function AddEmployee(props) {
  const [countryCodeList, setCountryCodeList] = useState([])
  const [countryCode, setCountryCode] = useState('');
  const [open, setOpen] = useState(false);
  const [employerId, setEmployerId] = useState('');
  const [govtID, setGovtID] = useState('')
  const [bankAccountNumber, setBankAccountNumber] = useState('')
  const [employerName, setEmployerName] = useState('');
  const [employerList, setEmployerList] = useState([]);
  const [birthDate, setBirthDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const history = useHistory();
  const [errorDisplay, seterrorDisplay] = useState('')
  const userInfo = JSON.parse(localStorage.getItem('loginUser'))
  const [userPayFrequency, setUserPayFrequency] = useState('')
  const [userPayFrequencyList, setUserPayFrequencyList] = useState([])
  const [userPayType, setUserPayType] = useState('')
  const [userPayTypesList, setUserPayTypesList] = useState([])
  const [userEmployment, setUserEmployment] = useState('')
  const [userStatus, setUserStatus] = useState('')
  const [userStatusList, setUserStatusList] = useState([])
  const [userEmploymentTypes, setUserEmploymentTypes] = useState([])
  const [empID, setEmpId] = useState('')
  const [email, setEmailId] = useState('')
  const maximumDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate()
  }
  const dobInputFormat = () => {
    if (!birthDate) return '';
    let date = setFormat(birthDate)
    var month = ("0" + (new Date(date).getMonth() + 1)).slice(-2);
    var day = ("0" + new Date(date).getDate()).slice(-2);
    return `${birthDate.year}-${month}-${day}`;
  }

  // const startDateInputFormat = () => {
  //   if (!startDate) return '';
  //   let date = setFormat(startDate)
  //   var month = ("0" + (new Date(date).getMonth() + 1)).slice(-2);
  //   var day = ("0" + new Date(date).getDate()).slice(-2);
  //   return `${startDate.year}-${month}-${day}`;
  // }

  const endDateInputFormat = () => {
    if (!endDate) return '';
    let date = setFormat(endDate)
    var month = ("0" + (new Date(date).getMonth() + 1)).slice(-2);
    var day = ("0" + new Date(date).getDate()).slice(-2);
    return `${endDate.year}-${month}-${day}`;
  }

  useEffect(() => {
    fatchCountryCodes();
    getEmployerData()
    fatchUserPayFrequency();
    fatchUserPayTypes();
    fatchUserEmploymentTypes();
    getUserStatus();
    if (props.match.params.id) {
      fetchUserDetails();
    }

    if (userInfo.roles === 3) {
      setEmployerId(userInfo.employer_code)
      setEmployerName(userInfo.first_name)
    }

    // eslint-disable-next-line
  }, [])

  const goBack = () => {
    history.goBack()
  }

  const fatchUserPayFrequency = () => {
    handleToggle()
    http('admin/user_pay_frequency_list/', 'GET')
      .then(res => {
        if (res.data.status) {
          
          // var response = res.data.data.map(element => {
            
          //   if(element.id !== 3 ){
          //     return element
          //   }
           
          // })
          
         var response =  res.data.data.filter(filterPayFrequency)
         console.log('response', response);
          setUserPayFrequencyList(response)
        }
        else {
          toast.error(res.data.message, {
            toastId: "toastId1"
          })

        }
        handleClose()
      },
        err => {
          handleClose()
          console.log('err....', err)
        })
  }

  const filterPayFrequency = (frequency) => {
    if(frequency.id !== 3 && frequency.id !== 1)
    return frequency
  }

  const fatchUserPayTypes = () => {
    handleToggle()
    http('admin/user_pay_types_list/', 'GET')
      .then(res => {
        if (res.data.status) {
          setUserPayTypesList(res.data.data)
        }
        else {
          toast.error(res.data.message, {
            toastId: "toastId2"
          })

        }
        handleClose()
      },
        err => {
          handleClose()
          console.log('err....', err)
        })
  }

  const getUserStatus = () => {
    handleToggle()
    http('admin/user_status_list/', 'GET')
      .then(res => {
        if (res.data.status) {
          setUserStatusList(res.data.data)
        }
        else {
          toast.error(res.data.message, {
            toastId: "toastId22"
          })

        }
        handleClose()
      },
        err => {
          handleClose()
          console.log('err....', err)
        })
  }

  const fatchUserEmploymentTypes = () => {
    handleToggle()
    http('admin/user_employeement_types_list/', 'GET')
      .then(res => {
        if (res.data.status) {
          setUserEmploymentTypes(res.data.data)
        }
        else {
          toast.error(res.data.message, {
            toastId: "toastId3"
          })

        }
        handleClose()
      },
        err => {
          handleClose()
          console.log('err....', err)
        })
  }

  const getEmployerData = () => {
    handleToggle()
    http('admin/company_all_list/', 'GET')
      .then(res => {
        if (res.data.status) {
          if (Array.isArray(res.data.data))
            setEmployerList(res.data.data)
          else {
            let arr = []
            arr.push(res.data.data)
            setEmployerList(arr)
          }

        }
        else {
          toast.error(res.data.message, {
            toastId: "toastId4"
          })
        }
        handleClose()
      },
        err => {
          handleClose()
          console.log('err....', err)
        })
  }

  const fatchCountryCodes = () => {
    handleToggle()
    http('account/phone_code_list/', 'GET')
      .then(res => {
        if (res.data.status) {
          setCountryCodeList(res.data.data)
        }
        else {
          toast.error(res.data.message, {
            toastId: "toastId5"
          })

        }
        handleClose()
      },
        err => {
          handleClose()
          console.log('err....', err)
        })
  }

  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };

  const submitForm = (event) => {
    event.preventDefault();
    var objValidation = {};
    objValidation = checkValidationFormAllControls(document.forms[0].elements, false, [])
    if (objValidation.valid !== false) {
      seterrorDisplay(objValidation);
      return;
    } else {
      seterrorDisplay(objValidation);
    }

    const data = new FormData(event.currentTarget);
    console.log('data',data);
    console.log(data.get('employee_id')  )
    const body = {
      id: props.match.params.id ? props.match.params.id : '',
      emp_id: props.match.params.id || userInfo.roles === 3  ?  empID : data.get('employee_id'),
      employer_id: employerId,
      employer_name: employerName,
      email:props.match.params.id || userInfo.roles === 3  ?  email : data.get('email'),
      phone_number: countryCode + data.get('phone_number'),
      first_name: data.get('first_name'),
      middle_name: data.get('middle_name'),
      last_name: data.get('last_name'),
      birth_date: birthDate ? setFormat(birthDate) : '',
      bank_account_number: data.get('bank_account_number'),
      govt_id: govtID,
      address_line_1: data.get('address_line_1'),
      address_line_2: data.get('address_line_2'),
      city: data.get('city'),
      region_code: data.get('region_code'),
      country_code: data.get('country_code'),
      postal_code: data.get('postal_code'),
      status: userStatus,
      status_start_date: startDate ? setFormat(startDate) : '',
      status_end_date: endDate ? setFormat(endDate) : '',
      employment_type: userEmployment,
      pay_type: userPayType,
      pay_frequency: userPayFrequency,
      pay_days: data.get('pay_days')
    }
    handleToggle()
    var url = props.match.params.id ? 'admin/update_employee/' : 'admin/add_new_employee/';
    var method = props.match.params.id ? 'PUT' : 'POST'
    http(url, method, body)
      .then(res => res.data)
      .then(res => {
        if (res.status) {
          // history.push("/employee-list");
          history.goBack()
          toast.success(res.message, {
            toastId: "toastId6"
          })
        }
        else {
          const error = getErrorResponse(res.message)
          toast.error(error, { toastId: "toastId7", allowHtml: true })
        }
        handleClose()
      })
      .catch(error => {
        toast.error("Something went wrong!", {
          toastId: "toastId8"
        })
        handleClose()
      });
  }

  const fetchUserDetails = () => {
    handleToggle()
    http('admin/update_employee/' + props.match.params.id, 'GET', '')
      .then(res => {
        if (res.status) {
          var employerData = res.data.data;
          var profile = employerData.profile;
          delete employerData.profile
          var objEmployer = Object.assign(profile, employerData)
          console.log(objEmployer , 'obj')
          setGovtID(objEmployer.govt_id)
          setBankAccountNumber(objEmployer.bank_account_number)
          var data = document.forms[0];
          setEmployerId(objEmployer.employer_id.trim())
          setEmployerName(objEmployer.employer_name)
          setUserStatus(objEmployer.status)
          Object.keys(objEmployer).forEach(element => {
            // debugger

            console.log(element , 'ele')
            if (element === 'emp_id') {
              data.elements['employee_id'].value = objEmployer[element]
              setEmpId(objEmployer[element])
              // localStorage.setItem('empId', objEmployer[element])
            }
            if (element === 'email') {
              data.elements['email'].value = objEmployer[element]
              setEmailId(objEmployer[element])
              // localStorage.setItem('email', objEmployer[element])
            }
            if (element === 'mobile') {
              data.elements['phone_number'].value = objEmployer[element]
            }
            if (element === 'country_code') {
              console.log('coountry code......')
              data.elements['country_code'].value = objEmployer[element]
            }

            if (element === 'status_start_date') {

              setStartDate(setDate(objEmployer[element]))

            }
            if (element === 'pay_frequency') {
              setUserPayFrequency(objEmployer[element])
            }
            if (element === 'employment_type') {
              setUserEmployment(objEmployer[element])
            }
            if (element === 'pay_type') {
              setUserPayType(objEmployer[element])
            }
            if (element === 'status') {
              // console.log(objEmployer[element],'mukul')
              // setUserStatus(objEmployer[element])
            }
            if (element === 'status_end_date') {
              if (objEmployer[element]) {
                setEndDate(setDate(objEmployer[element]))
              }
              console.log('end date......', endDate)
            }
            if (element === 'dob') {
              // data.elements['birth_date'].value = Moment(objEmployer[element]).format('MM/DD/YYYY')
              setBirthDate(setDate(objEmployer[element]))
            }

            if (element === 'phonecode') {
              setCountryCode(objEmployer[element])
            }
            if (data.elements[element]) {
              data.elements[element].value = objEmployer[element]
            }
          })
          console.log('objEmployer',objEmployer);

        }
        else {
         
          toast.error(res.message, {
            toastId: "toastId9"
          })
        }
        handleClose()
      },
        err => {
          handleClose()
          console.log('err....', err)
        });
  }

  const preventMinus = (e) => {
    if (e.code === 'Minus') {
      e.preventDefault();
    }
  };

  const preventKeyDown = (e) => {
    if (e.code === 'ArrowDown') {
      e.preventDefault();
    }
  }

  const setDate = (date) => {
    return {
      year: new Date(date).getFullYear(),
      month: new Date(date).getMonth() + 1,
      day: new Date(date).getDate()
    }
  }

  const setFormat = (date) => {
    if (date) {
      let year = date.year ?? ''
      let month = date.month ?? ''
      let day = date.day ?? ''
      return year + '-' + month + '-' + day
    }
    return ''
  }

  return (

    <div className='mainAppDiv'>
      <ToastContainer />

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Typography variant="h5" className='AddEmployerHeadding' gutterBottom component="div">
        {props.match.params.id ? 'Edit' : 'Add'} Employee
      </Typography>
      <form onSubmit={submitForm} noValidate sx={{ mt: 1 }} className="formInputHeight">
        <Grid container spacing={3}>
          <Grid item={true} xs={12} sm={6} md={4} >
            <TextField className={ props.match.params.id || userInfo.roles === 3  ? 'disabled' : '' }
              inputProps={{ disabled: props.match.params.id || userInfo.roles === 3 }}
              InputLabelProps={{ shrink: true }}
              required fullWidth label="Enter employee id " name='employee_id' id="employee_id" />
            {errorDisplay.employee_id ? <span style={{
              fontSize: '14px',
              color: '#dc0e0e'
            }}>{errorDisplay.employee_id}</span> : ''}
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4} >
            <FormControl fullWidth sx={{ m: 0, minWidth: 100 }} className="cityHeight">
              <InputLabel id="demo-simple-select-required-label">Employer id</InputLabel>
              <Select
                labelId="demo-simple-select-required-label"
                name='employer_id' id="employer_id"
                label="Please select employer"
                value={employerId}
                required
                inputProps={{ disabled: props.match.params.id || userInfo.roles === 3 }}
                onChange={(e) => {
                  setEmployerId(e.target.value)
                  if (userInfo.roles !== 3) {
                    const found = employerList.find(element => element.employer_id === e.target.value);
                    setEmployerName(found.name)
                  }
                }}
              >
                <MenuItem value="">Please select</MenuItem>
                {
                  employerList.map((data, index) => (
                    <MenuItem key={'data.code' + index} value={data.employer_id}>{data.name + " (" + data.employer_id + ")"}</MenuItem>
                  ))
                }
              </Select>
            </FormControl>
            {errorDisplay.employer_id ? <span style={{
              fontSize: '14px',
              color: '#dc0e0e'
            }}>{errorDisplay.employer_id}</span> : ''}
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4}>
            <TextField inputProps={{ disabled: props.match.params.id || userInfo.roles === 3 }} InputLabelProps={{ shrink: true }} required fullWidth label="Enter email" name='email' type="email" id="email" />
            {errorDisplay.email ? <span style={{
              fontSize: '14px',
              color: '#dc0e0e'
            }}>{errorDisplay.email}</span> : ''}
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4} >
            <Grid container spacing={3}>
              <Grid item={true} xs={6}>
                <FormControl fullWidth className="cityHeight">
                  <InputLabel id="demo-simple-select-required-label">Code</InputLabel>
                  <Select inputprops={{
                    readOnly: props.match.params.id ? true : false,
                    shrink: true
                  }}
                    labelId="demo-simple-select-required-label"
                    id="phone_code"
                    name='phone_code'
                    value={countryCode}
                    label="Phone Code"
                    onChange={(event) => {
                      setCountryCode(event.target.value)
                    }}
                  >
                    <MenuItem value="Please select" disabled>Please select</MenuItem>
                    {
                      countryCodeList.map((data, index) => (
                        <MenuItem key={'data.code' + index} value={data.code}>{data.name + " (" + data.code + ")"}</MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
              </Grid>

              <Grid item={true} xs={6} >
                <TextField inputprops={{
                  readOnly: props.match.params.id ? true : false,
                }} InputLabelProps={{ shrink: true }} required fullWidth label="Enter phone number" name='phone_number' id="phone_number" />
                {errorDisplay.phone_number ? <span style={{
                  fontSize: '14px',
                  color: '#dc0e0e'
                }}>{errorDisplay.phone_number}</span> : ''}
              </Grid>
            </Grid>
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} required fullWidth label="Enter first name" name='first_name' id="first_name" />
            {errorDisplay.first_name ? <span style={{
              fontSize: '14px',
              color: '#dc0e0e'
            }}>{errorDisplay.first_name}</span> : ''}
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} fullWidth label="Enter middle name" name='middle_name' id="middle_name" />
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} required fullWidth label="Enter last name" name='last_name' id="last_name" />
            {errorDisplay.last_name ? <span style={{
              fontSize: '14px',
              color: '#dc0e0e'
            }}>{errorDisplay.last_name}</span> : ''}
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4} >
            <div className="datePickerWidth">
              <DatePicker value={birthDate} onChange={(date) => { setBirthDate(date) }} inputPlaceholder="Enter birth date" maximumDate={maximumDate} shouldHighlightWeekends formatInputText={dobInputFormat} calendarPopperPosition='auto' />
            </div>
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4} >
            <TextField type="text" inputProps={{ disabled: props.match.params.id || userInfo.roles === 3 }} onKeyDown={preventKeyDown} onKeyPress={preventMinus} InputLabelProps={{ shrink: true }} fullWidth label="Enter bank account number" name='bank_account_number' id="bank_account_number" value={bankAccountNumber} onChange={(event) => {
              if (event.target.value.length === 11) return false;   //limits to 10 digit entry
              setBankAccountNumber(event?.target.value);       //saving input to state
            }} />
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4} >
            <TextField inputProps={{ type: 'number', maxLength: 11 }} onKeyDown={preventKeyDown} onKeyPress={preventMinus} InputLabelProps={{ shrink: true }} value={govtID} fullWidth label="Enter govt ID" name='govt_id' id="govt_id" onChange={(event) => {
              if (event.target.value.length === 17) return false;   //limits to 11 digit entry
              setGovtID(event?.target.value);       //saving input to state
            }} />
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} fullWidth label="Enter address line 1" name='address_line_1' id="address_line_1" />
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} fullWidth label="Enter address line 2" name='address_line_2' id="address_line_2" />
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} type="text" fullWidth label="Enter city" name='city' id="city" />
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} fullWidth label="Enter region code " name='region_code' id="region_code" />
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} fullWidth label="Enter country code" name='country_code' id="country_code" />
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} fullWidth label="Enter Postal Code" name='postal_code' id="postal_code" />
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4} >
            <FormControl fullWidth sx={{ m: 0, minWidth: 100 }} className="cityHeight">
              <InputLabel id="demo-simple-select-required-label">User Status</InputLabel>
              <Select labelId="demo-simple-select-required-label" name='status' id="status" label="Please select user status" value={userStatus} required inputProps={{ disabled: props.match.params.id }} onChange={(e) => { setUserStatus(e.target.value) }} >
                <MenuItem value="">Please select</MenuItem>
                {
                  userStatusList.map((data, index) => (
                    <MenuItem key={'data.name' + index} value={data.name}>{data.name}</MenuItem>
                  ))
                }
              </Select>
            </FormControl>
            {errorDisplay.status ? <span style={{ fontSize: '14px', color: '#dc0e0e' }}>{errorDisplay.status}</span> : ''}
          </Grid>




          <Grid item={true} xs={12} sm={6} md={4} >
            <div className="datePickerWidth">
              {/* <DatePicker value={startDate} calendarPopperPosition='auto' inputProps={{readOnly: true}}
                onChange={(date) => {
                  if (date) {
                    // date.preventDefault();
                    setStartDate(date);
                    if (Moment(setFormat(date)).valueOf() > Moment(setFormat(endDate)).valueOf()) {
                      setEndDate(date)
                    }
                  }
                }}
                inputPlaceholder="Enter status start date" maximumDate={endDate} shouldHighlightWeekends formatInputText={startDateInputFormat}
              /> */}
              <DatePicker
                customInput={<CustomInput />}
                value={startDate}
                inputPlaceholder="Enter Status Start Date" 
                inputProps={{readOnly: true}}
                onChange={(date) => {
                  if (date) {
                    // date.preventDefault();
                    setStartDate(date);
                    if (Moment(setFormat(date)).valueOf() > Moment(setFormat(endDate)).valueOf()) {
                      setEndDate(date)
                    }
                  }
                }}
              />
            </div>
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4} >
            <div className="datePickerWidth" style={{ position: "relative", zIndex: "999" }}>
              <DatePicker value={endDate} onChange={setEndDate} inputPlaceholder="Enter Status End Date" minimumDate={startDate} shouldHighlightWeekends formatInputText={endDateInputFormat} calendarPopperPosition='auto' />
            </div>
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4} >
            <FormControl fullWidth sx={{ m: 0, minWidth: 100 }} className="cityHeight">
              <InputLabel id="demo-simple-select-required-label">Employment Type</InputLabel>
              <Select labelId="demo-simple-select-required-label" name='employment_type' id="employment_type"
                label="Please select employment type" value={userEmployment}
                onChange={(e) => {
                  setUserPayFrequency(e.target.value)
                  const found = userEmploymentTypes.find(element => element.name === e.target.value);
                  setUserEmployment(found.name)
                }}
              >
                <MenuItem value="">Please select</MenuItem>
                {
                  userEmploymentTypes.map((data, index) => (
                    <MenuItem key={'data.name' + index} value={data.name}>{data.name}</MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4} >
            <FormControl fullWidth sx={{ m: 0, minWidth: 100 }} className="cityHeight">
              <InputLabel id="demo-simple-select-required-label">Pay Type</InputLabel>
              <Select labelId="demo-simple-select-required-label" name='pay_type' id="pay_type"
                label="Please select pay type" value={userPayType}
                onChange={(e) => {
                  setUserPayFrequency(e.target.value)
                  const found = userPayTypesList.find(element => element.name === e.target.value);
                  setUserPayType(found.name)
                }}
              >
                <MenuItem value="">Please select</MenuItem>
                {
                  userPayTypesList.map((data, index) => (
                    <MenuItem key={'data.name' + index} value={data.name}>{data.name}</MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4} >
            <FormControl fullWidth sx={{ m: 0, minWidth: 100 }} className="cityHeight">
              <InputLabel id="demo-simple-select-required-label">User pay frequency</InputLabel>
              <Select labelId="demo-simple-select-required-label" name='pay_frequency' id="pay_frequency"
                label="Please select user pay frequency" value={userPayFrequency} required
                onChange={(e) => {
                  setUserPayFrequency(e.target.value)
                  const found = userPayFrequencyList.find(element => element.name === e.target.value);
                  setUserPayFrequency(found.name)
                }}
              >
                <MenuItem value="">Please select</MenuItem>
                {
                  userPayFrequencyList.map((data, index) => (
                    <MenuItem key={'data.name' + index} value={data.name}>{data.name}</MenuItem>
                  ))
                }
              </Select>
            </FormControl>
            {errorDisplay.pay_frequency ? <span style={{
              fontSize: '14px',
              color: '#dc0e0e'
            }}>{errorDisplay.pay_frequency}</span> : ''}
          </Grid>

          <Grid item={true} xs={12} sm={6} md={4} >
            <TextField InputLabelProps={{ shrink: true }} fullWidth label="Enter pay days" name='pay_days' id="pay_days" />
          </Grid>
        </Grid>

        <div className='btnDiv'>
          <Grid container spacing={3} className='justifyEnd' sx={{ justifyContent: 'flex-end' }}>
            <Grid item={true} xs={12} className='gridbtnSubmit'>
              <button type='button' className='btnSubmit btnCancel' onClick={goBack}>Cancel</button>
              <button type='submit' className='btnSubmit'>Submit</button>
            </Grid>
          </Grid>
        </div>
      </form>
    </div>
  );
}

export default AddEmployee;